import script from "./GoogleSignInButton.vue?vue&type=script&setup=true&lang=js"
export * from "./GoogleSignInButton.vue?vue&type=script&setup=true&lang=js"

import "./GoogleSignInButton.vue?vue&type=style&index=0&id=7e7ee6d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e7ee6d4"]])

export default __exports__